import { render, staticRenderFns } from "./updateBLSB.vue?vue&type=template&id=38445b40&lang=pug&"
import script from "./updateBLSB.vue?vue&type=script&lang=js&"
export * from "./updateBLSB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports